import Image from "@tiptap/extension-image";

export const CustomImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      link: {
        default: null,
        parseHTML: (element: HTMLElement) => {
          const parent = element.parentElement;
          if (parent?.tagName === "A") {
            return parent.getAttribute("href");
          }
          return element.getAttribute("data-link");
        },
        renderHTML: (attributes: Record<string, unknown>) => {
          if (!attributes.link) return {};
          return { "data-link": attributes.link as string };
        },
      },
      linkTarget: {
        default: "_blank",
        parseHTML: (element: HTMLElement) => {
          const parent = element.parentElement;
          if (parent?.tagName === "A") {
            return parent.getAttribute("target") || "_blank";
          }
          return element.getAttribute("data-link-target") || "_blank";
        },
        renderHTML: (attributes: Record<string, unknown>) => {
          if (!attributes.linkTarget) return {};
          return { "data-link-target": attributes.linkTarget as string };
        },
      },
    };
  },
  parseHTML() {
    return [
      {
        tag: "img[src]",
      },
      {
        tag: "a > img[src]",
        getAttrs: (element: HTMLElement) => {
          const img = element as HTMLImageElement;
          const anchor = img.parentElement as HTMLAnchorElement;
          return {
            src: img.getAttribute("src"),
            alt: img.getAttribute("alt"),
            title: img.getAttribute("title"),
            link: anchor?.getAttribute("href"),
            linkTarget: anchor?.getAttribute("target") || "_blank",
          };
        },
      },
    ];
  },
});


